/**
 * トースト表示用の共通関数
 *
 * @param {Vue} vm - Vueインスタンス
 * @param {string} message - 表示するエラーメッセージ
 * @param {boolean} icon - 表示するアイコン
 */
export const showErrorToast = (vm, message, isShowErrorIcon = true) => {
    vm.$toasted.error(message, isShowErrorIcon ? { icon: "error" } : {});
};

/**
 * 成功トースト表示用の共通関数
 *
 * @param {Vue} vm - Vueインスタンス
 * @param {string} message - 表示するメッセージ
 */
export const showSuccessToast = (vm, message) => {
    vm.$toasted.success(message, { icon: "check_circle" });
};
